import React from "react";
import { SystemStyleObject } from "@mui/system";
import { Theme } from "@mui/material";
import { LicenseStylesColums } from "./LicenseColumns";

export const Colors = {
  green: LicenseStylesColums.statusColors.active.color,
  blue: LicenseStylesColums.statusColors.unassigned.color,
  red: LicenseStylesColums.statusColors.expired.bg,
  orange: "#FF9800",
  strongRed: LicenseStylesColums.statusColors.expired.color,
  grey: "rgba(33, 29, 38, .38)",
} as const;

export type Colors = (typeof Colors)[keyof typeof Colors];

export const filterButtonBoxSx: SystemStyleObject<Theme> = {
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  border: "1px solid rgba(0,0,0,0.15)",
  borderRadius: "6px",
  py: "8px",
  px: "12px",
  backgroundColor: "#fff",
  gap: "8px",
  userSelect: "none",
};

export const filterButtonBoxHoverSx: SystemStyleObject<Theme> = {
  backgroundColor: "rgba(0,0,0,0.04)",
};

export const filterButtonBoxNoHandlerSx: SystemStyleObject<Theme> = {
  cursor: "default",
  display: "inline-flex",
  alignItems: "center",
  border: "1px solid rgba(0,0,0,0.15)",
  borderRadius: "6px",
  py: "8px",
  px: "12px",
  backgroundColor: "#fff",
  gap: "8px",
  userSelect: "none",
};

export const titleStyle: React.CSSProperties = {
  fontSize: "0.75rem",
  color: "rgba(0,0,0,0.6)",
  whiteSpace: "nowrap",
};

export const valueStyle = (color: string): React.CSSProperties => ({
  fontSize: "0.8rem",
  fontWeight: 700,
  color,
});

export const separatorStyle: React.CSSProperties = {
  fontSize: "0.75rem",
  color: "rgba(0,0,0,0.3)",
};

export const eyeIconSx: SystemStyleObject<Theme> = {
  fontSize: "0.85rem",
  display: "block",
  lineHeight: 1,
  marginTop: 0,
  marginBottom: 0,
};

export const resolveValueColor = (
  value: number,
  color: Colors,
  emptyColor?: Colors,
): string => (value === 0 ? emptyColor || color : color);

export const resolveValue2Color = (
  value2: number,
  color: Colors,
  color2?: Colors,
  emptyColor2?: Colors,
): string => (value2 === 0 ? emptyColor2 || color2 || color : color2 || color);
